import { render, staticRenderFns } from "./ScatterSet.vue?vue&type=template&id=2822940c&scoped=true&"
import script from "./ScatterSet.vue?vue&type=script&lang=js&"
export * from "./ScatterSet.vue?vue&type=script&lang=js&"
import style0 from "./ScatterSet.vue?vue&type=style&index=0&id=2822940c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2822940c",
  null
  
)

export default component.exports